import { ReactNode } from 'react';
import styled from 'styled-components';
import {
    BackgroundProps,
    background,
    border,
    BorderProps,
    flexbox,
    FlexboxProps,
    layout,
    LayoutProps,
    position,
    PositionProps,
    shadow,
    ShadowProps,
    space,
    SpaceProps,
} from 'styled-system';
import { gap, GapProps } from '../utils/styled-components/gap';
import { color, ColorProps } from '../utils/styled-components/styledSystem';

export type FlexBoxProps = React.HTMLAttributes<HTMLDivElement> &
    SpaceProps &
    LayoutProps &
    FlexboxProps &
    BorderProps &
    PositionProps &
    ShadowProps &
    ColorProps &
    GapProps &
    BackgroundProps & {
        children?: ReactNode | ReactNode[];
        cursor?: string;
    };

export const FlexBox = styled.div<FlexBoxProps>`
    box-sizing: border-box;
    ${space}
    ${layout}
    ${flexbox}
    ${border}
    ${position}
    ${shadow}
    ${color}
    ${gap}
    ${background}
    ${({ cursor }) => cursor && `cursor: ${cursor};`}
`;

FlexBox.defaultProps = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
};

FlexBox.displayName = 'FlexBox';
